export default __webpack_public_path__ + "150a0aa0e049856de54eedd5c509ee4d.jpg";